/**
 * KrutiKala scroll-reveal
 * Figma Make: src/hooks/useInView.ts + .reveal / .in-view
 * Observes [data-kk-reveal] and adds .is-in-view once (threshold 0.12).
 */
(function () {
  const SELECTOR = '[data-kk-reveal]';
  const CLASS = 'is-in-view';

  function revealAll(root) {
    const nodes = Array.from((root || document).querySelectorAll(SELECTOR));
    if (!nodes.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      nodes.forEach((el) => el.classList.add(CLASS));
      return;
    }

    if (!('IntersectionObserver' in window)) {
      nodes.forEach((el) => el.classList.add(CLASS));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add(CLASS);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.12 }
    );

    nodes.forEach((el) => {
      if (!el.classList.contains(CLASS)) observer.observe(el);
    });
  }

  window.kkRevealAll = revealAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => revealAll(document), { once: true });
  } else {
    revealAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => revealAll(event.target));
})();
